<div
  class="tips"
  *ngIf="(offersState$ | async).loaded; else loading"
  [@fadeInOut]
>
  <app-page-header>Find your new product</app-page-header>
  <div>
    <div class="content container">
      <div class="grid-row">
        <div class="md-3"></div>
        <div class="md-6 xs-12 pl-6 pr-6">
          <div class="header">
            <h3 class="header-title">Before you start</h3>
            <p class="header-text">
              Read our quick tips to choose the right product and enjoy a smooth
              delivery.
            </p>
          </div>
          <div class="accordion">
            <dgx-components-accordion-panel
              [hasBorder]="true"
              [panel]="panels[0]"
              [panelIndex]="0"
              [accordionPanelContentTemplate]="whatsOnOffer"
              [accordionPanelHeaderTemplate]="accordionPanelHeaderTemplate"
              (toggle)="trackEvent($event)"
            >
              <ng-template
                #whatsOnOffer
                let-expanded="expanded"
                let-panel="panel"
              >
                <div class="tip purple">
                  <div class="tip-header">
                    <dgx-components-icon
                      [family]="'light'"
                      [name]="'arrow-circle-right'"
                      [size]="'sm'"
                    ></dgx-components-icon>
                    <span>Choose a similar model</span>
                  </div>
                  <div class="tip-body">
                    <p>
                      We’ll always offer you some models with the same or
                      similar specifications as your old one. The models we can
                      offer depend on what’s in stock at the time.
                    </p>
                  </div>
                </div>
                <div class="tip green">
                  <div class="tip-header">
                    <dgx-components-icon
                      [name]="'sparkles'"
                      [size]="'sm'"
                    ></dgx-components-icon>
                    <span>Or grab yourself an upgrade</span>
                  </div>
                  <div class="tip-body">
                    <p>
                      Why not go for a product with new and improved features?
                      We’ll offer you some for an extra fee if they’re
                      available.
                    </p>
                  </div>
                </div>
              </ng-template>
            </dgx-components-accordion-panel>

            <dgx-components-accordion-panel
              [hasBorder]="true"
              [panel]="panels[1]"
              [panelIndex]="1"
              [accordionPanelContentTemplate]="itWillFit"
              [accordionPanelHeaderTemplate]="accordionPanelHeaderTemplate"
              (toggle)="trackEvent($event)"
            >
              <ng-template #itWillFit let-expanded="expanded" let-panel="panel">
                <div class="tip yellow">
                  <div class="tip-header">
                    <dgx-components-icon
                      [name]="'circle-exclamation'"
                      [size]="'sm'"
                    ></dgx-components-icon>
                    <span>Measure up first</span>
                  </div>
                  <div class="tip-body">
                    <p>
                      How big is the space where the product will go? Also check
                      any doors or halls along the way.
                    </p>
                  </div>
                </div>
                <div class="tip purple">
                  <div class="tip-header">
                    <dgx-components-icon
                      [name]="'magnifying-glass'"
                      [size]="'sm'"
                    ></dgx-components-icon>
                    <span>Compare products</span>
                  </div>
                  <div class="tip-body">
                    <p>
                      We’ll ask you to compare the new options with your old
                      product. Be sure to check the size, energy type (gas or
                      electric) and whether it’s freestanding or integrated.
                    </p>
                  </div>
                </div>
              </ng-template>
            </dgx-components-accordion-panel>

            <dgx-components-accordion-panel
              [hasBorder]="true"
              [panel]="panels[2]"
              [panelIndex]="2"
              [accordionPanelContentTemplate]="delivery"
              [accordionPanelHeaderTemplate]="accordionPanelHeaderTemplate"
              (toggle)="trackEvent($event)"
            >
              <ng-template #delivery let-expanded="expanded" let-panel="panel">
                <div class="tip green">
                  <div class="tip-header">
                    <dgx-components-icon
                      [name]="'truck'"
                      [size]="'sm'"
                    ></dgx-components-icon>
                    <span>Free delivery</span>
                  </div>
                  <div class="tip-body">
                    <p>We’ll offer you this if it’s included in your plan.</p>
                  </div>
                </div>
                <div class="tip purple">
                  <div class="tip-header">
                    <dgx-components-icon
                      [name]="'recycle'"
                      [size]="'sm'"
                    ></dgx-components-icon>
                    <span>Installation and recycling</span>
                  </div>
                  <div class="tip-body">
                    <p>
                      We may offer to install your new product and remove the
                      old one for recycling, for an extra fee.
                    </p>
                  </div>
                </div>
              </ng-template>
            </dgx-components-accordion-panel>

            <dgx-components-accordion-panel
              [hasBorder]="true"
              [panel]="panels[3]"
              [panelIndex]="3"
              [accordionPanelContentTemplate]="protection"
              [accordionPanelHeaderTemplate]="accordionPanelHeaderTemplate"
              (toggle)="trackEvent($event)"
            >
              <ng-template
                #protection
                let-expanded="expanded"
                let-panel="panel"
              >
                <div class="tip purple">
                  <div class="tip-header">
                    <span
                      >Your protection plan ended because your product couldn’t
                      be fixed.</span
                    >
                  </div>
                  <div class="tip-body">
                    <p>
                      We may offer you a new protection policy to cover the
                      product you order now.
                    </p>
                  </div>
                </div>
              </ng-template>
            </dgx-components-accordion-panel>

            <ng-template
              #accordionPanelHeaderTemplate
              let-panel="panel"
              let-expanded="expanded"
            >
              <div class="flex align--center justify--space-between">
                <h5 class="panel-title">{{ panel.title }}</h5>
                <dgx-components-icon
                  [family]="'light'"
                  [name]="expanded ? 'circle-xmark' : 'circle-plus'"
                  [size]="'xl'"
                ></dgx-components-icon>
              </div>
            </ng-template>
          </div>

          <div class="pt-8">
            <dgx-components-button variant="primary" (clicked)="goToOffers()"
              >Browse new products</dgx-components-button
            >
          </div>
        </div>
        <div class="md-3"></div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="loading content">
    <app-loader [@fadeInOut]></app-loader>
  </div>
</ng-template>
